import { containerAddressesOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { ContainerAddressListDto } from "../api/types";
import { formatFullAddress } from "./FullAddress";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("container-address"),
  endpoint: "container-addresses",
  operations: containerAddressesOps,
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  infiniteNormalizer: (value) => {
    return {
      ...value,
      results: value.results.map((v: ContainerAddressListDto) => ({
        name: formatFullAddress(v),
        description: v.name,
        addressName: v.name,
        id: v.id,
      })),
    };
  },
  singularName: (t) => t("Address"),
  name: (t) => t("Address"),
  syncCustomerFilter: true,
});

export default conf;
